// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/cfit.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/cfit/cfit.js';

mount([g0]);
